import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { UserRole } from 'src/app/core/models/auth.models';
import { CompanyModel } from 'src/app/core/models/company.model';
import { UtilsService } from 'src/app/core/service/utils.service';
import { PermissionItem } from 'src/app/shared/checkbox-tree/checkbox-tree.component';

@Component({
  selector: 'app-subrole-modal',
  templateUrl: './subrole-modal.component.html',
  styleUrls: ['./subrole-modal.component.scss']
})
export class SubroleModalComponent implements OnInit {

  @Output() save: EventEmitter<any> = new EventEmitter();
  @ViewChild('modal') modal: ElementRef;
  modalRef: NgbModalRef;

  tree: PermissionItem[] = [];
  disabledTree: boolean = false;
  subrole: any = null;
  roles: any[];

  //Form
  form: FormGroup;
  submitted: boolean = false;

  constructor(private modalService: NgbModal,
    protected translate: TranslateService,
    public utilSrv: UtilsService) {
    this.roles = [
      { label: this.translate.instant('MISC.ADMIN'), value: UserRole.ADMIN },
      { label: this.translate.instant('MISC.MEMBER'), value: UserRole.MEMBER },
      { label: this.translate.instant('MISC.PARTNER'), value: UserRole.PARTNER },
      { label: this.translate.instant('MISC.CUSTOMER'), value: UserRole.CUSTOMER },
    ];
  }

  ngOnInit(): void {
    this.setForm();
  }

  get formCtrl() { return this.form.controls; }

  setForm() {
    this.form = new FormGroup({
      // role: new FormControl("", [Validators.required]),
      description: new FormControl("", [Validators.required]),
    });
  }

  //Check Tree Functions
  setChildsSelectedFalse(childs: any[]) {
    childs.forEach((element) => {
      element.selected = false;
      this.setChildsSelectedFalse(element.childs);
    });
  }

  populateTree(childs: any[], permissions: string[]) {
    childs.forEach((c) => {
      c.collapsed = true;
      if (permissions.includes(c.permission)) {
        c.selected = true;
      }
      this.populateTree(c.childs, permissions);
    });
  }

  allChildsSelected(parent: PermissionItem): any {
    if (parent.childs) {
      if (parent.childs.find((c) => c.selected)) {
        parent.selected = true;
      } else {
        if (!parent.childs.find((c) => c.selected)) {
          parent.selected = false;
        }
      }

      return (
        parent.childs.find((c) => !c.selected) &&
        parent.childs.find((c) => c.selected)
      );
    }

    return false;
  }

  onParentCollapse(parent: PermissionItem) {
    parent.collapsed = !parent.collapsed;
  }

  onParentChange(parent: PermissionItem) {
    if (parent.selected) {
      parent.childs.forEach((c: any) => {
        c.selected = true;
        this.onParentChange(c);
      });
    } else {
      parent.childs.forEach((c: any) => {
        c.selected = false;
        this.onParentChange(c);
      });
    }
  }

  getSelectedPermissions(childs: PermissionItem[]): string[] {
    let permissions: string[] = [];
    childs.forEach((c) => {
      const childPermission = this.getSelectedPermissions(c.childs);
      if (c.selected) {
        permissions.push(c.permission);
      } else {
        if (childPermission.length > 0)
          permissions.push(c.permission);
      }

      permissions.push(...childPermission);
    });
    return permissions;
  }

  //Modal
  open(tree: PermissionItem[], company: CompanyModel | null, subrole?: any): void {
    this.tree = tree;
    this.subrole = subrole;
    this.submitted = false;
    this.setChildsSelectedFalse(this.tree);

    if (this.subrole) {
      this.form.patchValue({
        ...subrole,
      });
      this.populateTree(this.tree, subrole.permissions);
    } else {
      this.setForm();
      this.populateTree(this.tree, []);
    }

    if (company && company.isInactive) {
      this.form.disable();
      this.disabledTree = true;
    } else {
      this.form.enable();
      this.disabledTree = false;
    }

    this.modalRef = this.modalService.open(this.modal, { centered: true, backdrop: 'static', keyboard: false });
  }

  submit() {
    this.submitted = true;

    if (!this.form.valid) {
      return;
    } else {
      this.save.emit({
        subrole: this.subrole,
        data: {
          ...this.form.value,
          permissions: this.getSelectedPermissions(this.tree),
        }
      });
      this.close();
    }
  }

  close() {
    this.modalRef.close();
    this.setForm();
  }

}
